import { Badge, BanCircleIcon, Heading, Icon, Pane, Text } from "evergreen-ui";

import { useListActiveOrderFlagsQuery } from "../../../v2/features/orderFlags/orderFlags.api";
import { matchOrderFlags } from "../../../v2/features/orderFlags/lib/matchFlags";

// Prominent "do not deliver" banner for the order detail page. Same DB source
// as the list badge (AlertBlock), but matches email + both phones (billing and
// delivery) so a reused number on either line is caught.
const OrderFlagBanner = ({ order }) => {
  const { data: flags } = useListActiveOrderFlagsQuery();
  if (!order) return null;

  const matched = matchOrderFlags(flags, order.email, [
    order.billingPhoneNumber,
    order.deliveryPhoneNumber,
  ]);
  if (matched.length === 0) return null;

  return (
    <Pane
      marginTop={16}
      padding={16}
      borderRadius={6}
      elevation={1}
      background="#b91c1c"
      display="flex"
      alignItems="flex-start"
    >
      <Icon icon={BanCircleIcon} color="white" size={28} marginRight={12} marginTop={2} />
      <Pane flex={1}>
        <Heading size={600} color="white">
          NU LIVRA aceasta comanda
        </Heading>
        {matched.map((tag) => (
          <Pane key={tag.code} marginTop={8} display="flex" alignItems="baseline">
            <Badge style={{ backgroundColor: tag.color || "#1f2937", color: "white" }} marginRight={8}>
              {tag.label}
            </Badge>
            {tag.description ? (
              <Text color="white" size={400}>
                {tag.description}
              </Text>
            ) : null}
          </Pane>
        ))}
      </Pane>
    </Pane>
  );
};

export default OrderFlagBanner;
